import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Button,
  Item,
} from "semantic-ui-react";
import EmployeeCertificateList from "./EmployeeCertificateList";
import { observer } from "mobx-react-lite";
import EmployeeCertificateStore from "../../../app/stores/employeecertificateStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { Link } from "react-router-dom";

const EmployeeCertificateDashboard: React.FC = () => {
  const employeecertificateStore = useContext(EmployeeCertificateStore);
  const {
    submitting,
    employeecertificate: initialFormState,
    loadEmployeeCertificates,
    loadCertificates,
    certificatesByName,
    uploadingFile,
  } = employeecertificateStore;

  useEffect(() => {
    // loadEmployeeCertificates();
    loadCertificates().then(() => loadEmployeeCertificates());
  }, []);

  if (employeecertificateStore.loadingInitial)
    return <LoadingComponent content="Loading EmployeeCertificates" />;
  
    if (uploadingFile) return <LoadingComponent content='Uploading photos...' />

  return (
    <Item>
          <Button
            as={Link}
            to={`/employeeportal/certificate-create`}
            color="linkedin"
            icon="add"
            content="Add New"
          />
          <EmployeeCertificateList />
    </Item>
  );
};

export default observer(EmployeeCertificateDashboard);
